/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  ImagesControllerProxyQueryResponse,
  ImagesControllerProxyQueryParams,
} from '../../types/ImagesControllerProxy.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { imagesProxy } from '../../methods/imagesProxy.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const imagesProxyQueryKey = (params: ImagesControllerProxyQueryParams) =>
  [{ url: '/api/images/proxy' }, ...(params ? [params] : [])] as const;

export type ImagesProxyQueryKey = ReturnType<typeof imagesProxyQueryKey>;

export function imagesProxyQueryOptions(
  params: ImagesControllerProxyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = imagesProxyQueryKey(params);
  return queryOptions<
    ImagesControllerProxyQueryResponse,
    ResponseErrorConfig<Error>,
    ImagesControllerProxyQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return imagesProxy(params, config);
    },
  });
}

/**
 * {@link /api/images/proxy}
 */
export function useImagesProxy<
  TData = ImagesControllerProxyQueryResponse,
  TQueryData = ImagesControllerProxyQueryResponse,
  TQueryKey extends QueryKey = ImagesProxyQueryKey,
>(
  params: ImagesControllerProxyQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<ImagesControllerProxyQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? imagesProxyQueryKey(params);

  const query = useQuery(
    {
      ...imagesProxyQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
